// src/components/auth/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';
import LoadingSpinner from '../ui/LoadingSpinner';

const ProtectedRoute = ({ children }) => {
  const { isSignedIn, isLoaded } = useUser();

  // Still loading Clerk session
  if (!isLoaded) {
    return (
      <div className="min-h-screen flex items-center justify-center pt-20">
        <LoadingSpinner size="xl" text="Checking authentication..." />
      </div>
    );
  }

  // Not signed in - redirect to login
  if (!isSignedIn) {
    return <Navigate to="/login" replace />;
  }

  // User is signed in - render children
  return children;
};

export default ProtectedRoute;